import { useQuickEdit } from '@/hooks/useQuickEdit';
import QuickEditWrapper from '@/components/quickedit/QuickEditWrapper';

interface CustomHtmlProps {
  section: any;
}

export default function CustomHtml({ section }: CustomHtmlProps) {
  const html = section.content?.html ?? '';
  const { isActive } = useQuickEdit();

  if (!html) return null;

  const content = (
    <section className="bg-[--bg-primary]">
      <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8">
        <div dangerouslySetInnerHTML={{ __html: html }} />
      </div>
    </section>
  );

  if (isActive) {
    return (
      <QuickEditWrapper href={`/admin/homepage`} label="Edit custom HTML section">
        {content}
      </QuickEditWrapper>
    );
  }

  return content;
}
